import { render, staticRenderFns } from "./zhengwuzhonghe.vue?vue&type=template&id=36ab8f6a&scoped=true&"
import script from "./zhengwuzhonghe.vue?vue&type=script&lang=js&"
export * from "./zhengwuzhonghe.vue?vue&type=script&lang=js&"
import style0 from "./zhengwuzhonghe.vue?vue&type=style&index=0&id=36ab8f6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ab8f6a",
  null
  
)

export default component.exports